import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/elements/Picture';
import { useNavigate } from 'react-router-dom';
import Image from 'components/elements/Image';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function BrokersAndAssetsWidget(props) {
    const auth = useSelector(store => store.auth);
    const { t } = useTranslation();
    const [tab, setTab] = useState(0);
    let navigate = useNavigate();

    if (!props?.title && !props?.image && !props?.img_mob && !props?.descriptions && !props?.additional_text && !props?.button_text && !props?.path && !props?.items) return null;

    return (
        <div data-test-id="baa-wr" className={"widget widget-brokersandassets" + (props?.dark ? " bg-dark" : "")}>
            <div className='container-xl row mx-auto p-0'>
                <div className="col-12 text-center">
                    {props?.title ? <h2 data-test-id="baa-title" className="text-color-changeable mb-20">{props?.title}</h2> : null}
                    {
                        props?.img?.source || props?.img_mob?.source ?
                            <Picture dti="baa-img" img={props.img} img_mob={props.img_mob} className='text-null col-12 col-md-6 mb-3 mb-md-0' />
                            : null
                    }
                    {props?.descriptions ? <p data-test-id="baa-description" className={(props?.dark ? 'text-white ' : '') + "text-sm-medium text-semibold mb-20"}>{props.descriptions}</p> : null}
                    {props?.additional_text ? <p data-test-id="baa-add-text" className="text-color-changeable text-semibold text-sm-medium text-italic mb-20">{props.additional_text}</p> : null}
                    {
                        props?.button_text && props?.path ?
                            <button
                                data-test-id="baa-btn"
                                onClick={() => {
                                    if (props.path) {
                                        if (auth && (props.path === '/auth' || props.path === 'auth')) {
                                            navigate('/price');
                                        } else {
                                            navigate(props.path);
                                        }
                                    }
                                }}
                                className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}
                            >
                                {props.button_text}
                            </button> : null
                    }
                </div>
                {
                    props?.items && props?.items.length ?
                        <div className="col-12 mt-5">
                            <div className={"slider w-100 d-flex justify-content-between align-items-center mx-auto mb-20 qty-" + props?.tabs?.length}>
                                {
                                    (props.tabs === undefined) ? null :
                                        [t('All'), ...props.tabs].map((tab_head, index) => {
                                            return (
                                                <button data-test-id={"baa-tab-" + tab_head} key={index} className={"slider-item text-white text-small text-bold p-0" + ((tab === index) ? " isActive" : "")}
                                                    onClick={() => { setTab(index) }}>
                                                    {t(tab_head)}
                                                </button>
                                            )
                                        })
                                }
                                <span className={'slider-runner d-block position-' + tab}></span>
                            </div>
                            {
                                (props.tabs === undefined) ? null :
                                    ['All', ...props.tabs].map((t, index) => {
                                        return (
                                            <div key={'slide_content_' + index} className={'slide-content' + (props?.dark ? ' bg-dark' : '') + (tab === index ? ' isActive' : '')}>
                                                <div className='row justify-content-center align-items-center'>
                                                    {
                                                        ((t === 'All') ? props.items : props.items.filter(obj => {
                                                            return obj.tab === t
                                                        })).map((i, index) => {
                                                            return (
                                                                <div key={'broker-wrapper' + index} className="col-6 col-sm-3 col-md-2 text-center">
                                                                    {
                                                                        i?.url ?
                                                                            <a
                                                                                data-test-id={"baa-logo-link-" + index}
                                                                                rel="noreferrer"
                                                                                href={i.url}
                                                                                target="_blank"
                                                                                className="w-100"
                                                                            >
                                                                                <Image dti={"baa-logo-" + index} img={i?.img} className="w-100" />
                                                                            </a>
                                                                            :
                                                                            <Image
                                                                                dti={"baa-logo-" + index}
                                                                                img={i?.img}
                                                                                className="w-100"/>
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })
                            }
                        </div> : null
                }
            </div>
        </div>
    )
}

BrokersAndAssetsWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.object,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
}

export default BrokersAndAssetsWidget;
